import 'construct-style-sheets-polyfill'; const styleSheet = new CSSStyleSheet(); styleSheet.replaceSync(`:host {
    display: flex;
    flex-wrap: wrap;
    margin-top: calc(var(--inv-grid-gutter-y, 0) * -1);
    margin-right: calc(var(--inv-grid-gutter-x, 1.5em) * -0.5);
    margin-left: calc(var(--inv-grid-gutter-x, 1.5em) * -0.5);
}
`); export default styleSheet;